import { createContext } from 'react';

// ----------------------------------------------------------------------

export const AuthContext = createContext({
    authenticated: false,
    loading: true,
    user: null, 
  });
  
